import { useNavigate } from "react-router";
import { hasModule, useMe } from "../lib/auth";
import { ObligationList } from "../features/obligations/ObligationList";
import { PageHeader } from "../app/PageHeader";

/** Onderhoud en keuringen over alle gebouwen, voor de planner (docs/ASSETS-MJOP.md, "Organisatie-overzicht"). */
export function ObligationsPage() {
  const { data: me } = useMe();
  const navigate = useNavigate();
  if (!hasModule(me, "assets"))
    return (
      <div className="center">
        <p>Geen toegang tot de module Assets.</p>
      </div>
    );
  return (
    <div className="page">
      <PageHeader label="Assets" title="Onderhoud en keuringen" />
      <p className="muted small">
        Alle keuringen, inspecties, controles en onderhoud bij assets en gebouwen, op vervaldatum. Verlopen wettelijke
        keuringen krijg je ook direct per mail.
      </p>
      <ObligationList
        onOpenAsset={(r) => navigate(`/gebouwen/${r.building.id}?${r.asset ? `asset=${r.asset.id}` : "gebouw=1"}`)}
      />
    </div>
  );
}
